import type { SVGProps } from 'react';
const actionDots = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      fill={props.color ?? '#144761'}
      fillRule="evenodd"
      xmlns="http://www.w3.org/2000/svg"
    />
  </svg>
);
export default actionDots;
